import React from "react";



function DeleteButton({ selectedItems }) {
  console.log(selectedItems);
  



  return (
    <>
    <div className={`${selectedItems.length < 1 && "hidden"}`}>
      <div className="flex items-center">
        <div className="hidden xl:block text-sm italic mr-2 whitespace-nowrap">
          <span>{selectedItems.length}</span> items selected
        </div>
        <button
          className="btn bg-white border-gray-200 hover:border-gray-300 text-red-500 hover:text-red-600"
        >
          Delete
        </button>
      </div>
    </div>

    </>
  );
}

export default DeleteButton;